import { render, staticRenderFns } from "./product-base-form.vue?vue&type=template&id=4a1f577a&scoped=true&"
import script from "./product-base-form.vue?vue&type=script&lang=js&"
export * from "./product-base-form.vue?vue&type=script&lang=js&"
import style0 from "./product-base-form.vue?vue&type=style&index=0&id=4a1f577a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1f577a",
  null
  
)

export default component.exports